module.exports = __webpack_public_path__ + "img/add-circle.d04d08ff.svg";